function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { chain, maxBy } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { MainQuestionEdit } from 'src/_candidato/data/main-question';
var PanelMainQuestionsComponentCtrl = /*#__PURE__*/function () {
  PanelMainQuestionsComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function PanelMainQuestionsComponentCtrl($log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelMainQuestionsComponentCtrl);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelMainQuestionsComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info('[PanelMainQuestionsComponentCtrl] onInit');
      this.AccesoDatos.MainQuestions_CLIENT.todasLasPregPrincipalesConPreg().then(function (responseList) {
        _this.list = chain(responseList).map(function (mq) {
          return new MainQuestionEdit(mq);
        }).value();
      });
    }
  }, {
    key: "nuevaMainQ",
    value: function nuevaMainQ() {
      var maxmq = maxBy(this.list, function (mq1) {
        return mq1.data.mq.orden;
      });
      var mq = new MainQuestionEdit({
        mq: {
          noactivo: false,
          usar_busquedas: true,
          usar_listado: true,
          orden: !!maxmq ? (maxmq.data.mq.orden || 0) + 1 : 1
        }
      });
      mq.nuevoreg = true;
      this.list.push(mq);
    }
  }]);
}();
angular.module('candidato').component('panelMainQuestions', {
  bindings: {},
  controller: PanelMainQuestionsComponentCtrl,
  // templateUrl: "panel-main-questions.component.html",
  template: require('./panel-main-questions.component.html')
});